import { useEffect, useState } from 'react'
import useImpressionTracker from 'react-impression-tracker'
import { DoctorForUser } from '@unni/api-client/contracts/doctor'

import TagList from '@/components/atomic/organisms/TagList'
import { DoctorProfile } from '@/features/hospital/components/doctor-list/doctor-profile'

interface Props {
  doctor: DoctorForUser
  defaultText?: {
    doctor?: string
    ceo?: string
    review?: string
  }
  isImpressionTrackerActive?: boolean
  onClickDoctorProfile?: () => void
  onImpressed?: () => void
}

export const DoctorView = ({
  doctor,
  defaultText,
  isImpressionTrackerActive = false,
  onClickDoctorProfile,
  onImpressed,
}: Props) => {
  const [isImpressionVisible, setIsImpressionVisible] = useState(false)

  const { targetRef, startTracking } = useImpressionTracker<HTMLDivElement, Record<string, never>>({
    context: {},
    onImpressed: () => {
      if (isImpressionTrackerActive && onImpressed) {
        onImpressed()
      }
    },
    isImpressionVisible,
    hasImpressed: false,
    rootMargin: '-22px',
  })

  useEffect(() => {
    localStorage && setIsImpressionVisible(localStorage.getItem('isImpressionVisible') === 'true')

    isImpressionTrackerActive && startTracking()
  }, [])

  return (
    <div ref={targetRef}>
      <DoctorProfile doctor={doctor} defaultText={defaultText} handleClick={onClickDoctorProfile} />
      <div className="mt-[10px]">
        <TagList tags={doctor.treatmentTags?.map((tag) => tag.name) || []} />
      </div>
    </div>
  )
}
